<template>
  <div class="row">
    <div class="col">
      <div class="bg-white px-[24px] py-[32px] mt-[16px] rounded-[4px]">
        <h2 class="font-bold text-[20px] leading-[20px] text-[#2463EB] w-full">
          Sales Order {{ purchaseOrder.orderNumber }}
        </h2>
        <div class="">
          <div class="">
            <div class="mt-[27px]">
              <div class="flex items-center w-full">
                <label for="inputPassword"
                  class="text-[#96A0B5] text-[16px] pt-[5px] font-normal leading-[19.64px] max-w-[90px] w-full">Order
                  for:</label>
                <input type="text" class="font-semibold text-[16px] text-[#353535] leading-[19.64px]"
                  :value="purchaseOrder.parent ? purchaseOrder.parent.name : ''" />
              </div>
              <div class="mt-[32px]" v-if="purchaseOrder.deliveryAddress">
                <label for="inputPassword"
                  class="text-[#96A0B5] text-[14px] font-medium leading-[20px] max-w-[150px] w-full">Delivery
                  Address:</label>
                <input
                  class="w-full border py-[10px] px-[16px] text-[14px] font-normal text-[#353535] focus:outline-none outline-none"
                  readonly="true" :value="purchaseOrder.deliveryAddress" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white px-[24px] py-[32px] mt-[16px] rounded-[4px]">
        <ItemDetails :items="addedOrderDetails" @performEdit="onEdit" @onRemoveHandler="onDetailRemoveHandler"
          :quotes="quotes" :purchaseOrder="purchaseOrder" :type="'edit'" @updateLoader="handleLoaderUpdate" />
        <SalesOrderItem v-if="addedItems.length > 0" :items="addedItems" @onRemove="onRemoveHandler" />
        <div class="mt-[16px] flex justify-end">
          <div class="flex items-center gap-[8px] max-w-[400px]">
            <div v-if="needsQuote && hasChanged" class="flex items-center gap-[8px]">
              <button type="button" @click="getQuote"
                class="bg-[#2463eb] border-[#2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
                :disabled="isBusy || isBusyModal || isItemDetailsLoading">
                <span v-if="gettingQuote">Generating Quote...</span>
                <span v-else>Update Quote</span>
              </button>
            </div>
            <div v-if="!needsQuote" class="flex items-center gap-[8px]">
              <button type="button"
                class="bg-[#fcfcfd] border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
                @click="closeModal" :disabled="isBusyModal || isBusy || isItemDetailsLoading">
                Cancel
              </button>
              <button type="button"
                class="bg-[#2463eb] border-[#2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
                :disabled="isBusyModal || isBusy || isItemDetailsLoading" @click="onUpdateClick">
                <span v-if="isBusyModal">Loading...</span>
                <span v-else>Update</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddEditProduct :products="manufacturerProducts" :edit="product" :items="addedOrderDetails"
      @onAddEditComplete="onAddEditComplete" :groupId="groupId" @onItemAdded="onItemAddHandler"
      @onItemUpdated="onItemUpdatedHandler" @cancel="onCancel" :purchaseOrder="purchaseOrder"
      @updateLoader="handleLoaderUpdate" />
    <ApplyOrderItem :orderItems="filteredOrderItems" @applyItem="onItemApply" />
    <UpdateOrderCaution :orderNumber="purchaseOrder.orderNumber" @onProceedClick="submit" :closeModal="closeModal" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import { helper } from "@/helper";
import Quantity from "./Quantity.vue";
import StageOptions from "./StageOptions";
import ItemDetails from "./PurchaseOrderItemDetails";
import SalesOrderItem from "./SalesOrderItem.vue";
import AddEditProduct from "./AddProduct.vue";
import ApplyOrderItem from "./ApplyOrderItem.vue";
import UpdateOrderCaution from "./UpdateOrderCaution.vue";
import { bus } from "../../main";
export default {
  props: [
    "orderId",
    "toggleEditMode",
    "closeModal",
    "manufacturerProducts",
    "refreshOrder",
    "PurchaseOrder",
  ],
  components: {
    Quantity,
    StageOptions,
    ItemDetails,
    AddEditProduct,
    ApplyOrderItem,
    SalesOrderItem,
    UpdateOrderCaution,
  },
  data() {
    return {
      isBusy: false,
      isBusyModal: false,
      groupId: "",
      filteredProducts: [],
      purchaseOrder: {
        contact: {},
      },
      addedOrderDetails: [],
      originalOrderDetails: [],
      product: null,
      stageCautionData: {},
      orderItems: [],
      filteredOrderItems: [],
      addedItems: [],
      isItemDetailsLoading: false,
      gettingQuote: false,
      quotes: [],
      hasChanged: false,
      initialized: false,
    };
  },
  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },
    isSubmitDisabled() {
      return this.isBusyModal || isBusy || this.isItemDetailsLoading;
    },
    needsQuote() {
      return this.addedOrderDetails.length > 0 && this.addedOrderDetails.some(item => !item.price || item.price === 0);
    },
  },
  created() {
    this.orderId = this.orderId;
    this.getOrderItems();
    this.editPurchaseOrder();
    bus.$on('updateLoader', (loaderState) => {
      this.isItemDetailsLoading = loaderState;
    });
  },
  beforeDestroy() {
    bus.$off('updateLoader');
  },
  methods: {
    handleLoaderUpdate(loaderState) {
      this.isItemDetailsLoading = loaderState;
    },
    ...mapActions(["getPurchaseOrder"]),
    getPurchaseOrder() {
      this.$store.dispatch("getPurchaseOrder", "enterprise");
    },
    emitCloseModal() {
      this.$emit("closeModal");
    },
    async editPurchaseOrder() {
      this.isBusy = true;
      this.initialized = false;
      try {
        const response = await this.$http.get(
          "/PurchaseOrders/edit/" + this.orderId
        );
        if (response.ok) {
          this.purchaseOrder = response.body;
          this.prepareDetailSet(this.purchaseOrder.details);
          this.prepareItemSet(this.purchaseOrder.orderItems);
          this.getGroup(this.purchaseOrder.parentId);
          this.originalOrderDetails = JSON.parse(JSON.stringify(this.addedOrderDetails));
          this.quotes = [];
          this.initialized = true;
          this.hasChanged = false;
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.$toast.error("Failed to fetch order. Please try again.", {
          icon: true,
          rtl: false,
        });
      }
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    onEdit(product) {
      const tempProduct = this.manufacturerProducts.find(
        (p) => p.id === product.id
      );
      this.product = {
        productId: product.id,
        quantity: product.quantity,
        name: tempProduct.name,
        productName: tempProduct.name,
        productCode: tempProduct.code,
        productCategory: product.category ? product.category.name : "",
      };
      // eslint-disable-next-line no-undef
      $("#mod-product-add").modal("show");
    },
    onCancel() {
      this.product = null;
      // eslint-disable-next-line no-undef
      $("#mod-product-add").modal("hide");
    },
    onAddEditComplete() {
      // eslint-disable-next-line no-undef
      $("#mod-product-add").modal("hide");
      this.onComplete();
    },
    onComplete() {
      this.editPurchaseOrder();
    },
    formatDate(date) {
      if (date) return moment(date).format("lll");
      else return "";
    },
    performFilter() {
      this.addedOrderDetails.forEach((element) => {
        this.filteredProducts = this.filteredProducts.filter(
          (product) => product.id !== element.id
        );
      });
    },
    performItemFilter() {
      this.addedItems.forEach((element) => {
        this.filteredOrderItems = this.filteredOrderItems.filter(
          (item) => item.id !== element.id
        );
      });
    },
    itemsChanged() {
      if (this.addedOrderDetails.length !== this.originalOrderDetails.length) {
        return true;
      }
      return this.addedOrderDetails.some((item, index) => {
        const original = this.originalOrderDetails[index];
        return (
          item.id !== original.id ||
          item.productCode !== original.productCode ||
          item.quantity !== original.quantity ||
          item.description !== original.description
        );
      });
    },
    onItemAddHandler(newItem) {
      const product = this.manufacturerProducts.find(
        (product) => product.id === newItem.productId
      );
      this.filteredProducts = this.filteredProducts.filter(
        (product) => product.id !== newItem.productId
      );
      this.prepareItem(product, newItem);
      this.hasChanged = true;
      this.quotes = [];
      this.addedOrderDetails = this.addedOrderDetails.map(item => ({
        ...item,
        price: undefined
      }));
    },
    onDetailRemoveHandler(itemId) {
      const product = this.manufacturerProducts.find(
        (product) => product.id === itemId
      );
      this.filteredProducts.push(product);
      this.addedOrderDetails = this.addedOrderDetails.filter(
        (x) => x.id !== itemId
      );
      bus.$emit("itemAdded", {
        type: "delete",
        data: { productCode: product.code },
      });
      this.hasChanged = true;
      this.quotes = [];
      this.addedOrderDetails = this.addedOrderDetails.map(item => ({
        ...item,
        price: undefined
      }));
    },
    onItemUpdatedHandler(newItem) {
      this.filteredProducts = this.filteredProducts.filter(
        (product) => product.id !== newItem.productId
      );
      this.prepareUpdateItem(newItem);
    },
    prepareUpdateItem(newItem) {
      this.addedOrderDetails = this.addedOrderDetails.map((item) => {
        if (item.id === newItem.productId) {
          const tempProduct = this.manufacturerProducts.find(
            (p) => p.id === newItem.productId
          );
          return {
            ...item,
            quantity: newItem.quantity,
            productCode: tempProduct.code,
            productCategory: tempProduct.category ? tempProduct.category.name : "",
            price: undefined,
          };
        }
        return item;
      });
      this.product = null;
      this.hasChanged = true;
      this.quotes = [];
      this.addedOrderDetails = this.addedOrderDetails.map(item => ({
        ...item,
        price: undefined
      }));
      // eslint-disable-next-line no-undef
      $("#mod-product-add").modal("hide");
    },
    prepareItem(product, newItem) {
      const preparedItem = {
        quantity: newItem.quantity,
        description: `${product.name}`,
        id: product.id,
        productCode: product.code,
        productName: newItem.name,
        productCategory: product.category ? product.category.name : "",
        division: product.sapDivision,
        productTax: product.sapTaxClassification,
        price: undefined,
      };
      this.addedOrderDetails.push(preparedItem);
      bus.$emit("itemAdded", { type: "add", data: preparedItem });
      // eslint-disable-next-line no-undef
      $("#mod-product-add").modal("hide");
    },
    prepareItemSet(orderItems) {
      this.addedItems = [];
      orderItems.forEach((element) => {
        this.orderItems.forEach((sub) => {
          if (element.orderItemId === sub.id) this.addedItems.push(sub);
        });
      });
      this.performItemFilter();
    },
    prepareDetailSet(productsDetails) {
      this.addedOrderDetails = [];
      productsDetails.forEach((element) => {
        let product =
          this.PurchaseOrder.details.find(
            (v) => v.productId == element.productId
          ) || {};
        const preparedItem = {
          productCode: product.product ? product.product.code : "",
          quantity: element.quantity,
          id: element.productId,
          price: element.price,
          description: product.product ? product.product.name : "",
          productTax: product.product ? product.product.sapTaxClassification : "",
        };
        this.addedOrderDetails.push(preparedItem);
      });
    },
    onUpdateClick() {
      // eslint-disable-next-line no-undef
      $("#mod-update-order-caution").modal("show");
    },
    async getQuote() {
      if (this.addedOrderDetails.length === 0) {
        this.quotes = [];
        this.gettingQuote = false;
        return;
      }
      this.gettingQuote = true;
      try {
        const swanCodes = [1200000060, 1200000063, 1200000064, 1200000061, 1200000065, 1200009366];
        const itemCodes = this.addedOrderDetails.map(item => Number(item.productCode));
        const hasAllowed = itemCodes.some(code => swanCodes.includes(code));
        const hasOther = itemCodes.some(code => !swanCodes.includes(code));
        if (hasAllowed && hasOther) {
          this.$toast.error(
            `Cannot get Quote..... Order contains products with different pricing schemes. Please correct and try again`,
            {
              icon: true,
              rtl: false,
            }
          );
          this.gettingQuote = false;
          return;
        }
        const data = {
          orderNumber: this.purchaseOrder.orderNumber,
          deliveryAddress: this.purchaseOrder.deliveryAddress,
          details: this.addedOrderDetails.map(item => ({
            productCode: item.productCode,
            productTax: item.productTax,
            quantity: item.quantity,
            id: item.id,
            description: item.description,
          })),
          orderContact: {
            name: this.purchaseOrder.parent.name,
            phoneNumber: this.purchaseOrder.parent.phoneNumber,
            email: this.purchaseOrder.parent.emailAddress,
          },
          status: this.purchaseOrder.status,
          specialInstructions: this.purchaseOrder.specialInstructions,
          discountAmount: 0,
          customerTax: this.purchaseOrder.parent.sapTaxClassification,
          distributorCode: this.purchaseOrder.parent.code,
        };
        const response = await this.$http.post(`/PurchaseOrders/adminGetSapSalesQuote`, data);
        if (response.ok) {
          this.quotes = response.body;
          this.addedOrderDetails = this.addedOrderDetails.map(item => {
            const quotePrice = this.quotes && this.quotes.productPrices
              ? this.quotes.productPrices.find(p => p.productCode === item.productCode)
              : null;
            return {
              ...item,
              price: quotePrice ? quotePrice.amountPerQuantity : 0,
            };
          });
          if (!this.quotes || !this.quotes.productPrices || this.quotes.productPrices.length === 0) {
            this.$toast.error("We Cannnot retrieve your quote at this moment. Please try again. Thank you", {
              icon: true,
              rtl: false,
            });
          }
        }
        this.gettingQuote = false;
      } catch (error) {
        this.$toast.error("Failed to retrieve quote", { icon: true, rtl: false });
        this.gettingQuote = false;
        this.quotes = [];
        this.addedOrderDetails = this.addedOrderDetails.map(item => ({
          ...item,
          price: undefined
        }));
      }
    },
    async submit() {
      if (!this.hasChanged || !this.itemsChanged()) {
        console.log("No changes detected:", { hasChanged: this.hasChanged, itemsChanged: this.itemsChanged() });
        this.$toast.info("Order was not edited. No changes will be made to the order.", {
          icon: true,
          rtl: false,
        });
        setTimeout(() => {
          this.closeModal();
          $("#mod-update-order-caution").modal("hide");
        }, 4000);
        return;
      }
      if (this.needsQuote) {
        this.$toast.error("No valid prices available. Please fetch prices.", {
          icon: false,
          rtl: false,
        });
        $("#mod-update-order-caution").modal("hide");
        return;
      }
      let url = this.user.isSalesUser ? "/PurchaseOrders/salesforce" : "/PurchaseOrders/manufacturer";
      this.isBusy = true;
      this.isBusyModal = true;
      const data = {
        details: this.addedOrderDetails.map(item => {
          const productPrice = this.quotes.productPrices.find(
            priceInfo => priceInfo.productCode === item.productCode
          );
          return {
            productCode: item.productCode,
            quantity: item.quantity,
            id: item.id,
            description: item.description,
            price: productPrice ? productPrice.amountPerQuantity : 0,
          };
        }),
        orderItems: this.addedItems,
        discountAmount: 0,
        sapQuoteNumber: this.quotes.quoteNumber,
      };
      try {
        const response = await this.$http.put(`${url}/update/${this.purchaseOrder.id}`, data);
        if (response.status === 201 && response.ok) {
          this.$toast.success(
            `The order (${this.purchaseOrder.orderNumber}) was successfully updated`,
            {
              icon: true,
              rtl: false,
            }
          );
          this.closeModal();
          $("#mod-update-order-caution").modal("hide");
        }
      } catch (error) {
        this.$toast.error("Failed to update the order", {
          icon: true,
          rtl: false,
        });
      } finally {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },
    async getOrderItems() {
      this.isBusyModal = true;
      try {
        const response = await this.$http.get("/PurchaseOrders/orderItem/list");
        if (response.ok) {
          this.orderItems = this.filteredOrderItems = response.body;
        }
        this.isBusyModal = false;
      } catch (error) {
        this.isBusyModal = false;
        this.$toast.error("Failed to fetch order items. Please try again.", {
          icon: true,
          rtl: false,
        });
      }
    },
    onItemApply(itemId) {
      // eslint-disable-next-line no-undef
      $("#mod-apply-order-item").modal("hide");
      const item = this.orderItems.find((x) => x.id === itemId);
      this.addedItems.push(item);
      this.filteredOrderItems = this.filteredOrderItems.filter(
        (item) => item.id !== itemId
      );
    },
    onRemoveHandler(itemId) {
      this.addedItems = this.addedItems.filter((x) => x.id !== itemId);
    },
    async getGroup(parentId) {
      this.isBusy = true;
      try {
        const response = await this.$http.get(
          `/Groups/getGroup/${parentId}`
        );
        if (response.ok) {
          this.groupId = response.body;
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.$toast.error("Failed to fetch group. Please try again.", {
          icon: true,
          rtl: false,
        });
      }
    },
  },
};
</script>